<template>
    <div>
        <!-- Feature settings -->
        <v-card class="mb-3" v-if="company">
            <v-card-title>
                <div>
                    <h3 class="saSecondary--text">{{
            $t("super.admin.company.member.manage.advance.features.title") }}</h3>
                    <div>
                        <h5 class="greyDarken3--text">{{
            $t("super.admin.company.member.manage.advance.features.subtitle") }}
                        </h5>
                    </div>
                </div>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <!-- Basic info -->
                <div v-for="feature in advanceFeatures" :key="feature">
                    <v-layout v-if="feature == 'DailyCo' && featureSettings[feature]" row wrap class="mb-3">
                        <v-flex xs12 md3 class="pr-2 pb-2">
                            <div class="headline saSecondary--text">
                                {{ $t(`super.admin.company.member.manage.feature.section.${feature}.title`) }}
                            </div>
                            <div class="greyDarken3--text body-1">
                                {{ $t(`super.admin.company.member.manage.feature.section.${feature}.subtitle`) }}
                            </div>
                        </v-flex>
                        <v-flex xs12 md9>
                            <v-checkbox class="px-2" :label="$t('super.admin.company.member.manage.feature.section.DailyCo.configuration.active.label')" v-model="featureSettings[feature].isActive"></v-checkbox>
                            <v-layout class="mb-3" row wrap>
                                <!-- <v-flex xs6 class="px-2">
                                    <v-text-field
                                        name="user_name"
                                        outline
                                        :label="$t('super.admin.company.member.manage.feature.section.DailyCo.configuration.enable.user.name.label')"
                                        v-model="featureSettings[feature].config.user_name"
                                    ></v-text-field>
                                </v-flex> -->
                                <v-flex xs6 px-2>
                                    <v-text-field
                                        name="daily_user_name"
                                        outline
                                        :label="$t('super.admin.company.member.manage.feature.section.DailyCo.configuration.enable.room.name.label')"
                                        v-model="featureSettings[feature].config.room_name"
                                    ></v-text-field>
                                </v-flex>
                                <!-- <v-flex class="px-2" xs6>
                                    <v-checkbox :label="$t('super.admin.company.member.manage.feature.section.DailyCo.configuration.enable.screen.share.label')" v-model="featureSettings[feature].config.enable_screenshare"></v-checkbox>
                                </v-flex> -->
                                <!-- <v-flex class="px-2" xs6>
                                    <v-checkbox :label="$t('super.admin.company.member.manage.feature.section.DailyCo.configuration.enable.recording.label')" v-model="featureSettings[feature].config.enable_recording"></v-checkbox>
                                </v-flex> -->
                                <v-flex v-if="featureSettings[feature].meeting_url" xs12 class="px-2">
                                    <v-text-field
                                        name="name"
                                        label="Admin Meeting URL"
                                        outline
                                        hide-details
                                        box
                                        type="text"
                                        :value="featureSettings[feature].meeting_url"
                                        append-outer-icon="mdi-file-multiple"
                                        @click:append-outer="$copyText(featureSettings[feature].meeting_url)"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 pt-3>
                                    <v-card-actions>
                                        <v-btn @click="generateDailyCoMeetingURL()" :loading="loading" small color="primary">Save</v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </div>

            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import DEFINES from "@/defines";
export default {
    name: "ManageAdvanceFeatures",
    props: {
        company: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            featureSettings: DEFINES.COMPANY_FEATURE_SETTINGS,
            loading: false
        }
    },
    mounted() {
        this.initializeFeatureSettings()
    },
    computed: {
        advanceFeatures() {
            return Object.keys(DEFINES.COMPANY_FEATURE_SETTINGS)
        }
    },
    methods: {
        initializeFeatureSettings() {
            if (!this.company.feature_settings) {
                return this.featureSettings = DEFINES.COMPANY_FEATURE_SETTINGS
            }

            return this.featureSettings = Object.assign({}, this.company.feature_settings)
        },

        async generateDailyCoMeetingURL() {
            this.loading = true
            await this.$store.dispatch('adminCompany/generateDailyCoMeetingURL', {
                company_id: this.company.id,
                data: this.featureSettings.DailyCo
            })
            .then((response) => {
                this.$store.dispatch("app/showMessage", {
                    message: "Your request has been proceed successfully!",
                    color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
                });
                this.$emit('update:company', response.company)
                this.company = response.company
                this.initializeFeatureSettings()
            })
            .catch((error) => {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: this.DEFINES.SNACKBAR_ERROR_COLOR,
                });
            })
            .finally(() => {
                this.loading = false
            })
        },
    }
}

</script>
